import { Link, useSearchParams } from "react-router-dom";
import styled from "styled-components";
import { withInvestorQuery, getInvestorQueryParams } from "../../utils/investorRouteHelpers";

const TabBar = styled.nav`
  margin-bottom: 1.75rem;
`;

const TabList = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.35rem;
  background: #ececec;
  border-radius: 14px;
  border: 1px solid #e0e0e0;
  max-width: 100%;
  overflow-x: auto;

  @media (max-width: 480px) {
    display: flex;
    width: 100%;
  }
`;

const TabLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.65rem 0.9rem;
  border-radius: 11px;
  font-size: 0.82rem;
  font-weight: 600;
  text-decoration: none;
  white-space: nowrap;
  color: #525252;
  background: transparent;
  transition: background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    color: #383838;
    background: rgba(255, 255, 255, 0.55);
  }

  &[aria-current="page"] {
    color: #383838;
    background: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }

  @media (max-width: 480px) {
    flex: 1;
    font-size: 0.72rem;
    padding: 0.6rem 0.45rem;
  }
`;

export const REQUEST_FILTERS = [
  { id: "all", label: "All" },
  { id: "investment", label: "Investments" },
  { id: "marketplace", label: "Marketplace" },
  { id: "real_estate", label: "Real Estate" },
];

function buildFilterHref(filterId, searchParams) {
  const query = getInvestorQueryParams(searchParams);
  return withInvestorQuery("/invest/requests", { ...query, filter: filterId === "all" ? "" : filterId });
}

export function getRequestFilter(searchParams) {
  const raw = searchParams?.get?.("filter") || searchParams?.filter || "all";
  const allowed = REQUEST_FILTERS.map((f) => f.id);
  return allowed.includes(raw) ? raw : "all";
}

export default function InvestorRequestsNav() {
  const [searchParams] = useSearchParams();
  const activeFilter = getRequestFilter(searchParams);

  return (
    <TabBar aria-label="Request filters" data-tour="invest-requests-tabs">
      <TabList role="tablist">
        {REQUEST_FILTERS.map((tab) => (
          <TabLink
            key={tab.id}
            to={buildFilterHref(tab.id, searchParams)}
            role="tab"
            aria-current={activeFilter === tab.id ? "page" : undefined}
          >
            {tab.label}
          </TabLink>
        ))}
      </TabList>
    </TabBar>
  );
}
